<template>
    <div>
        <div class="header">
            <div class="logout-bg" @click="logout">
                中止
            </div>
<!--            <div class="header-countdown-time">-->
<!--                {{ countdownTimeStr }}-->
<!--            </div>-->
            <div class="login-bg" @click="back">
                戻る
            </div>
            <div class="header-title">{{title}}</div>

        </div>
        <div class="container">
            <div v-for="(item,index) in questionList"
                 class="question-item" v-bind:key="index">
                <div class="question-content">
                    質問{{(index+1)}}：「{{item.title}}」
                </div>
                <div class="question-options">
                   <div :class="item.answerIndex === id?'question-option-item-selected':'question-option-item'"
                        v-for="(option,id) in item.answer" v-bind:key="id" @click="answerClick(index,id)">
                       {{option}}
                   </div>
                </div>
                <div v-if="item.type === 2" class="question-other-div">
                    <input class="question-other" :placeholder='item.freeword_hint?item.freeword_hint:"フリーワードによる入力"' v-model="item.description"/>
                </div>
            </div>
        </div>
        <div class="btn-bg" @click="saveAnswer">
            入力完了
        </div>
        <div style="height: 2vw"></div>
        <custom-dialog v-show="showMessage" :show-message="showMessage" :sub-message='subMessage'
                       @dialogClick="dialogClick" :type="dialogType"/>
        <custom-dialog v-show="showMessage2" :show-message="showMessage2" :sub-message='subMessage'
                       @dialogClick="dialogClick2" :type="dialogType"/>
    </div>
</template>
<script>

import {EXIT_DATA_SAVE_TIPS} from "@/store/message";
import CustomDialog from "@/components/CustomDialog.vue";
import {getEnquiteList, saveEnquiteAnswer} from "@/utils/api";
import {SHOP_ID} from "@/store/mutation-types";

export default {
    name: 'enquiteIndex',
    components: {
        CustomDialog
    },
    data() {
        return {
            countdownTime: 600,
            countdownTimeStr: '',
            dialogType: 0,
            showMessage: false,
            showMessage2: false,
            subMessage: "",
            title:"",
            state: 0,
            taskId: null,
            questionList:[],
            // questionList:[
            //     {
            //         "title":'问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字问题文字',
            //         "answer":["選択①", "選択②", "選択③", "選択④"],
            //         "other":''
            //     },
            //     {
            //         "question":'',
            //         "options":["選択①", "選択②", "選択③", "選択④"],
            //         "other":''
            //     },
            //     {
            //         "question":'',
            //         "options":["選択①", "選択②", "選択③", "選択④"],
            //         "other":''
            //     },
            //     {
            //         "question":'',
            //         "options":["選択①", "選択②", "選択③", "選択④"],
            //         "other":''
            //     },
            //     {
            //         "question":'',
            //         "options":["選択①", "選択②", "選択③", "選択④"],
            //         "other":''
            //     },
            //
            // ],
            answer:[],
            carId:'',
            serviceType:'',
            customerId:''

        }
    },
    mounted() {
        // let that = this;
        // that.taskId = setInterval(function () {
        //     that.countdown();
        //
        // }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.taskId)
    },
    created() {
        let that = this;
        if (that.$route.params.customerId){
            that.$set(that,'customerId',that.$route.params.customerId)
        }
        if (that.$route.params.carId){
            that.$set(that,'carId',that.$route.params.carId)
        }
        if (that.$route.params.type){
            that.$set(that,'serviceType',that.$route.params.type)
            console.log('type',that.$route.params.type)
            if (that.$route.params.type == 1){
                that.$set(that,"title","愛車査定申込書");
            }else if (that.$route.params.type == 2){
                that.$set(that,"title","車検見積お申込書");
            }
            console.log('title',that.title)
        }


        document.addEventListener('touchstart', function () {
            that.handleTouchStart()
        }, true);
        const loadingInstance1 = that.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
        });
        getEnquiteList(that.$route.params.type)
            .then(function (res) {
                console.log(JSON.stringify(res));
                if (res && res.data && res.data.length > 0){
                    that.$set(that,'questionList',res.data)
                }else {
                    that.$set(that,'questionList',[])
                }
                loadingInstance1.close();
            })
            .catch(function (err){
                console.error(err)
                loadingInstance1.close();
            })

    },
    methods: {
        countdown() {
            let that = this;
            let diff = that.countdownTime;
            diff--;
            if (diff <= 0) {
                window.document.location = "/ss/menu.php";
                clearInterval(that.taskId)
                return
            }

            let minutes = Math.floor((diff / 60));
            let seconds = Math.floor((diff % 60));
            that.$set(that, 'countdownTimeStr', `${minutes}:${seconds<10?'0'+seconds:seconds}`)
            that.$set(that, 'countdownTime', diff)
        },
        handleTouchStart() {
            console.log('handleTouchStart')
            if (this.countdownTime !== 600) {
                this.$set(this, 'countdownTime', 600)
            }
        },
        logout() {
            this.state = -1;
            this.showMessageDialog("中止ボタンが押されました。\n何も操作をせずに、そのままスタッフに\nこの端末をお渡しください。", 2)

        },
        back() {
            this.state = -3;
            this.showMessageDialog(EXIT_DATA_SAVE_TIPS, 2)
        },
        dialogClick(val) {
            console.log("dialogClick"+val);
            var that = this;
            that.$set(that, 'showMessage', false)
            that.$set(that, 'subMessage', '')
            if (val) {
                if (that.state === -1) {
                    that.$set(that, 'state', -2)
                    var message = "査定依頼を取り消します。\nよろしいですか？";
                    if (that.serviceType == 2){
                        message = "車検お見積もり依頼を取り消 します。\nよろしいですか？";
                    }
                    that.showMessageDialog2(message, 1)
                }else if (that.state === -3) {
                    that.$set(that, 'state', 0)
                    that.$router.back();
                }else if (that.state === 1){
                    that.$router.push("/pr");
                }
                else {
                    that.$set(that, 'state', 0)
                }
            }
        },
        dialogClick2(val) {
            console.log("dialogClick"+val);
            var that = this;
            that.$set(that, 'showMessage2', false)
            that.$set(that, 'subMessage', '')
            if (val) {
                if (that.state === -2) {
                    // window.location.href='https://www.shima-clc.com'
                    // window.location.reload();
                    // that.$router.go(0);
                    window.document.location = "/ss/menu.php";
                    that.$set(that, 'state', 0)
                } else {
                    that.$set(that, 'state', 0)
                }
            }
        },
        showMessageDialog2(subMessage, dialogType) {
            console.log("showMessageDialog"+subMessage);
            this.$set(this, 'showMessage2', true)
            this.$set(this, 'dialogType', dialogType)
            this.$set(this, 'subMessage', subMessage)
        },
        showMessageDialog(subMessage, dialogType) {
            console.log("showMessageDialog"+subMessage);
            this.$set(this, 'showMessage', true)
            this.$set(this, 'dialogType', dialogType)
            this.$set(this, 'subMessage', subMessage)
        },
        answerClick(questionIndex,answerIndex){
            this.$set(this.questionList[questionIndex], 'answerIndex', answerIndex)
        },
        saveAnswer(){
            let that = this
            const loadingInstance1 = that.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
            });
            let questionAnswerlist = [];
            for (let i = 0; i < that.questionList.length; i++) {
                if (that.questionList[i] && that.questionList[i].answerIndex !== null && that.questionList[i].answerIndex>=0){
                    let temp = {
                        titleId:that.questionList[i].id,
                        answer:that.questionList[i].answer[that.questionList[i].answerIndex],
                        description:that.questionList[i].description
                    }
                    questionAnswerlist.push(temp)
                }
            }
            saveEnquiteAnswer(localStorage.getItem(SHOP_ID),that.customerId,that.carId,that.serviceType,JSON.stringify(questionAnswerlist))
                .then(function (res){
                    console.log(JSON.stringify(res))

                    // window.document.location = "/ss";
                    loadingInstance1.close();
                    that.state = 1;
                    that.showMessageDialog("登録してよろしいですか", 2)
                })
                .catch(function (err){
                    console.error(err)
                    loadingInstance1.close();
                })
        }

    }
}
</script>

<style scoped>
.header {
    background: #416ADB;
    height: 8vw;
}

.header-title {
    color: white;
    font-size: 3vw;
    height: 8vw;
    line-height: 8vw;
    margin: 0 auto;
}

.header-countdown-time {
    display: flex;
    color: white;
    font-size: 2.2vw;
    position: absolute;
    float: right;
    right: 0;
    margin-top: 1.5vw;
    margin-right: 3.5vw;
}

.container {
    text-align: center;
    margin: 3vw auto 1vw auto;
    overflow-y: auto;
    min-height: 200px;
}
.question-item{
    border: 0.05vw solid #083A7E;
    border-radius: 1vw;
    padding: 1vw 2vw;
    margin: 1vw 4vw;
}
.question-content{
    text-align: left;
    font-size: 2.5vw;
    color: #212529;
}
.question-options{
    display: flex;
    flex-wrap: wrap;
}
.question-option-item{
    border: 0.1vw solid #083A7E;
    line-height: 6vw;
    min-height: 6vw;
    background: #FFFFFF;
    color: #083A7E;
    font-size: 2.6vw;
    margin: 1vw;
    border-radius: 1vw;
    min-width: 9vw;
    padding-left: 1vw;
    padding-right: 1vw;
}
.question-option-item-selected{
    border: 0.1vw solid #083A7E;
    border-radius: 1vw;
    line-height: 6vw;
    min-height: 6vw;
    color: #FFFFFF;
    background: #083A7E;
    font-size: 2.6vw;
    margin: 1vw;
    min-width: 9vw;
    padding-left: 1vw;
    padding-right: 1vw;
}
.question-other-div{
    display: flex;
    flex: 1;
    margin-left: 1vw;
    margin-right: 1vw;
    border: #212529 solid 0.1vw;
    border-radius: 1vw;
}
.question-other{
    font-size: 2.6vw;
    margin: 0.5vw 1vw;
    width: 100%;
    border-style: none;
}

.logout-bg {
    margin: 1.5vw 3vw;
    background: #e7373d;
    font-size: 2.4vw;
    padding: 0.8vw 5vw;
    border-radius: 0.8vw;
    color: #FFFFFF;
    border-width: 0.4vw;
    border-color: #891F25;
    border-style: none none solid none;
    position: absolute;
}

.login-bg {
    margin: 1.5vw 3vw;
    background: #f7bc34;
    font-size: 2.4vw;
    padding: 0.8vw 5vw;
    border-radius: 0.8vw;
    color: #FFFFFF;
    border-width: 0.4vw;
    border-color: #93721f;
    border-style: none none solid none;
    position: absolute;
    right: 10vw;
}


.btn-bg {
    margin: 2vw auto;
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 3vw;
    width: 40vw;
}

.btn-bg-left {
    position: absolute;
    left: 4vw;
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 3vw;
    width: 18vw;
}

.btn-bg-right {
    position: absolute;
    right: 4vw;
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 3vw;
    width: 18vw;
}
</style>